<script lang="ts">
	import PromptCard from "./PromptCard.svelte";

	import { deviceCheck } from "$lib/helpers/user";

	export let install = false;

	$: install;

	$: {
		if (install) {
			window.addEventListener("beforeinstallprompt", (e) => {
				e.preventDefault();
				const prompt = e as any;
				prompt.prompt();
				prompt.userChoice.then((choiceResult: any) => {
					if (choiceResult.outcome === "accepted") {
						console.log("User accepted the A2HS prompt");
					} else {
						console.log("User dismissed the A2HS prompt");
					}
				});
			});
		}
	}
</script>

<button
	type="button"
	on:click={() => (install = !install)}
	class="block w-fit rounded-full bg-opal p-2 text-sm font-medium text-white shadow-sm hover:bg-opal-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
	>Get the App</button
>

{#key install}
	{#if install}
		<PromptCard deviceType={deviceCheck()?.deviceType} />
	{/if}
{/key}
